export default {
    methods: {
        async getToken(path, client_id, client_secret) {
            return new Promise((resolve, reject) => {
                fetch(path, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        'client_id': client_id,
                        'client_secret': client_secret,
                        'grant_type': 'client_credentials'
                    })
                })
                    .then(response => response.json())
                    .then(data => {
                        resolve(data);
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        reject();
                    });
            })
        },
    }
}
